import * as React from 'react';
import { getBasePath } from '../../utils/browser';
import IconImage, { IconImageColorFilterProps } from './IconImage';
import BaseButton, { BaseButtonState } from './BaseButton';

interface IconButtonProps {
  readonly onClick?: () => void;
  readonly imagePath: string;
  readonly href?: string;
  readonly style?: React.CSSProperties;
  readonly imageStyle?: React.CSSProperties;
  readonly svgStyle?: React.CSSProperties;
  readonly rouondRect?: boolean;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly active?: boolean;
  readonly disabled?: boolean;
  readonly margin?: boolean;
  readonly colorFilter?: IconImageColorFilterProps;
}

const buttonStyle: React.CSSProperties = {
  width: '48px',
  height: '48px',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  justifyContent: 'center',
  color: 'inherit',
  textDecoration: 'none',
  background: 'rgba(0, 0, 0, 0.1)',
  boxSizing: 'border-box',
  overflow: 'hidden',
};

const render = (state: BaseButtonState, props: IconButtonProps): JSX.Element => {
  const {
    imagePath, style, imageStyle, svgStyle, rouondRect, active, disabled, margin, colorFilter,
  } = props;

  const buttonAdditionalStyle: React.CSSProperties = {};
  if (margin !== false) {
    buttonAdditionalStyle.margin = '8px';
  }

  let stateName = 'out';
  if (active) {
    buttonAdditionalStyle.outline = '2px solid white';
  }
  if (disabled) {
    stateName = 'disable';
  }
  if (!disabled && state.hovered && !state.pressed) {
    stateName = 'over';
  }
  if (state.pressed) {
    stateName = 'selected';
  }

  const baseDir = getBasePath();
  const imgSrc = `${baseDir}/${imagePath}_${stateName}.png`;

  const rouondRectStyle: React.CSSProperties | null = rouondRect
    ? { borderRadius: '4px', overflow: 'hidden' }
    : null;

  return(
    <div style={{ ...buttonStyle, ...buttonAdditionalStyle, ...rouondRectStyle, ...style }} >
      <IconImage src={imgSrc} style={imageStyle} svgStyle={svgStyle} { ...colorFilter } />
    </div>
  );
};

const ToolIconButton: React.SFC<IconButtonProps> = React.memo((props) => {
  const { onClick, href, title, ariaLabel, active, disabled } = props;

  return (
    <BaseButton
      render={state => render(state, props)}
      onClick={onClick}
      href={href}
      title={title}
      ariaLabel={ariaLabel}
      active={active}
      disabled={disabled} />
  );
});

export default ToolIconButton;
